// Static content manager to replace Contentful API
class StaticContentManager {
  constructor() {
    this.contentData = null;
    this.loading = false;
  }

  async getEntries() {
    if (this.contentData) {
      return { items: this.contentData };
    }

    this.loading = true;
    
    try {
      // For now, return static content directly
      // In the future, you could load from a JSON file
      this.contentData = [
        {
          sys: {
            id: '4foIHMFcStSULLslCfU60N', // Ratkaisut page ID
            contentType: {
              sys: {
                id: 'page'
              }
            }
          },
          fields: {
            name: 'Ratkaisut',
            title: 'Luovilla ratkaisuilla aktivoivaa markkinointia',
            content: `<p><em>Sanoma Games</em> on vuodesta 2007 toimittanut asiakaspelejä ja ratkaisuja sadoilta eri yrityksiltä miljoonille käyttäjille.</p>
<p>Lisäksi tarjoamme viihdettä noin 300 000 eri käyttäjälle viikoittain sivustojemme ja visojemme kautta. Toimitamme valmiit tuotteet asiakkaan toiveiden mukaisesti ja lisäksi tarjoamme edullisia näkyvyysratkaisuja olemassa oleville tuotteille.</p>
<p>Asiakkaitamme ovat esimerkiksi <strong>FAZER</strong>, <strong>TELIA</strong>, <strong>FINNAIR</strong>, <strong>SJL</strong>, <strong>YLE</strong>, <strong>Verkkokauppa.com</strong>, <strong>FUPO</strong>, <strong>VARTA</strong>, <strong>KIA</strong>, <strong>SKODA</strong> ja <strong>MORA</strong>.</p>`,
            slug: 'ratkaisut'
          }
        },
        {
          sys: {
            id: '46GtmlpYbSIUKAc6wEgaKy', // Me page ID
            contentType: {
              sys: {
                id: 'page'
              }
            }
          },
          fields: {
            name: 'Me',
            title: 'Viihdyttävää viestintää vuodesta 2007',
            content: `<p>Sanoma Gamesin tuottamiin ratkaisuihin voi törmätä monessa paikassa. Kolme päätuotettamme ovat kuitenkin pysyneet samoina läpi vuosien.</p>
<p><strong>Pelikone.fi</strong> on vuonna 2007 lanseerattu taukopelisivusto, joka nousi nopeasti Suomen suurimmaksi ja on pitänyt kärkipaikkaa aina tähän päivään asti. Pelikoneessa on tuhansia eri selainpelejä ja lisäksi paljon omaa tuotantoamme suomalaisten suosikki selainpelien muodossa. Pelikoneen pelaajista suurin osa on aikuisia naisia ja Pelikone.fi olikin useamman vuoden ajan suomen suurin naistenmedia.</p>
<p><strong>Älypää.com</strong> on tuttu monelle netin käyttäjälle. Suomen suosituin visailusivusto on perustettu jo vuonna 1998 ja virallisena Helsingin Sanomien pääyhteistyökumppanina luonnollinen siirtymä toi Älypään osaksi Sanoma Gamesin portfoliota. Älypään visoja on voinut pelata muun muassa Nokian puhelimissa, TV:ssä ja Photo Play peliautomaateissa joten brändi on tuttu monille suomalaisille. Älypään laadukkaat visat, testit ja ratkaisut soveltuvat erinomaisesti markkinointi ja koulutustarkoituksiin.</p>
<p><strong>IS Liigapörssi</strong> on toiminut Liigan virallisena valmentajapelinä jo vuodesta 1995 ja jokainen suomalainen onkin päässyt kasaamaan oman joukkueensa Liigan tähdistä jo yli 20 vuoden ajan. Liigapörssi siirtyi nettiaikaan 2000-luvun taitteessa ja 2008 alkaen pelissä on ollut mukana myös SM-liigan lisäksi KHL:n suomalaisjoukkueet.</p>`,
            slug: 'me'
          }
        },
        {
          sys: {
            id: 'ota-yhteytta-id',
            contentType: {
              sys: {
                id: 'page'
              }
            }
          },
          fields: {
            name: 'Ota yhteyttä',
            title: 'Ota yhteyttä Sanoma Gamesiin',
            content: `<p>Otamme mielellämme vastaan yhteydenottoja ja kysymyksiä. Kerro meille miten voimme auttaa sinua!</p>`,
            slug: 'ota-yhteytta'
          }
        },
        {
          sys: {
            id: 'tyoelama-id',
            contentType: {
              sys: {
                id: 'page'
              }
            }
          },
          fields: {
            name: 'Työelämän pelit',
            title: 'Pelillisiä ratkaisuja työelämään',
            content: `<p>Tarjoamme pelillisiä ratkaisuja työelämään ja koulutukseen.</p>`,
            slug: 'tyoelama'
          }
        },
        // Add some case studies
        {
          sys: {
            id: 'case-fazer',
            contentType: {
              sys: {
                id: 'case'
              }
            }
          },
          fields: {
            title: 'Fazer Karkkitesti',
            description: '<p>Fazer Karkkitesti oli hauska interaktiivinen peli, jossa käyttäjät pääsivät testaamaan tietämystään Fazerin karkeista.</p>',
            photo: {
              fields: {
                file: {
                  url: '/src/images/fazer.jpg'
                }
              }
            }
          }
        },
        {
          sys: {
            id: 'case-finnair',
            contentType: {
              sys: {
                id: 'case'
              }
            }
          },
          fields: {
            title: 'Finnair Kampanja',
            description: '<p>Finnair-aiheinen kampanja, jossa testattiin käyttäjien tietämystä lentoyhtiöstä ja matkustamisesta.</p>',
            photo: {
              fields: {
                file: {
                  url: '/src/images/finnair.jpg'
                }
              }
            }
          }
        },
        {
          sys: {
            id: 'case-sjl',
            contentType: {
              sys: {
                id: 'case'
              }
            }
          },
          fields: {
            title: 'SJL Kisa',
            description: '<p>Suomen Jääkiekkoliigan virallinen kisa-peli, jossa fanit pääsivät kilpailemaan keskenään.</p>',
            photo: {
              fields: {
                file: {
                  url: '/src/images/SJL_kisa.jpg'
                }
              }
            }
          }
        },
        {
          sys: {
            id: 'case-skoda',
            contentType: {
              sys: {
                id: 'case'
              }
            }
          },
          fields: {
            title: 'Skoda Kampanja',
            description: '<p>Skoda-automerkin kanssa toteutettu pelillinen markkinointikampanja.</p>',
            photo: {
              fields: {
                file: {
                  url: '/src/images/skoda.jpg'
                }
              }
            }
          }
        },
        {
          sys: {
            id: 'case-mora',
            contentType: {
              sys: {
                id: 'case'
              }
            }
          },
          fields: {
            title: 'Mora Kampanja',
            description: '<p>Mora-brändin kanssa kehitetty interaktiivinen peli ja kampanja.</p>',
            photo: {
              fields: {
                file: {
                  url: '/src/images/mora.jpg'
                }
              }
            }
          }
        },
        {
          sys: {
            id: 'case-telia',
            contentType: {
              sys: {
                id: 'case'
              }
            }
          },
          fields: {
            title: 'Telia Kampanja',
            description: '<p>Telia-kampanjapeli, joka yhdisti viihteen ja brändin tunnettuuden kasvattamisen.</p>',
            photo: {
              fields: {
                file: {
                  url: '/src/images/telia.jpg'
                }
              }
            }
          }
        },
        {
          sys: {
            id: 'case-kirja',
            contentType: {
              sys: {
                id: 'case'
              }
            }
          },
          fields: {
            title: 'Kirjalahjakone',
            description: '<p>Kirjalahjakone - interaktiivinen peli, joka auttoi käyttäjiä löytämään sopivia kirjalahjoja.</p>',
            photo: {
              fields: {
                file: {
                  url: '/src/images/kirjalahjakone.jpg'
                }
              }
            }
          }
        },
        {
          sys: {
            id: 'case-fupo',
            contentType: {
              sys: {
                id: 'case'
              }
            }
          },
          fields: {
            title: 'FUPO Kia',
            description: '<p>FUPO ja Kia yhteistyökampanja, jossa yhdistettiin auto-aihe ja pelimekaniikka.</p>',
            photo: {
              fields: {
                file: {
                  url: '/src/images/FUPO_Kia.jpg'
                }
              }
            }
          }
        }
      ];
      
      this.loading = false;
      
      return { items: this.contentData };
    } catch (error) {
      console.error('Error loading static content:', error);
      this.loading = false;
      throw error;
    }
  }

  getEntry(id) {
    if (!this.contentData) {
      throw new Error('Content not loaded. Call getEntries() first.');
    }
    
    return this.contentData.find(item => item.sys.id === id);
  }
}

// Create a singleton instance
const staticContentManager = new StaticContentManager();

export default staticContentManager;
